export default __webpack_public_path__ + "static/media/deliveryVisuals@3x.f9be7f93.png";